import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapsComponent } from './maps/maps.component';
import { NameBranchComponent } from './name-branch/name-branch.component';
import { IonicModule } from '@ionic/angular';
import { PipeModule } from '../pipes/pipe-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralesComponentsModule } from '../generales-components/generales-components.module';

const declarations = [
  MapsComponent,
  NameBranchComponent
]

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    PipeModule,
    TranslateModule,
    GeneralesComponentsModule
  ],
  exports: declarations
})
export class MapsComponentsModule { }
